import { routeConfig } from "#web/configs/route";
import { i18nLike } from "#web/services/i18nLike";
import { BlockStack, Button, ButtonGroup, Card, InlineStack, Layout, Text } from "@shopify/polaris";
import { XSmallIcon } from "@shopify/polaris-icons";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const en = {
  bookCall: "Book a call",
  description:
    "Onboard & safeguard your store in 15 minutes. Complete the setup or schedule a call with us to get a walkthrough.",
  otherCouponProtectionApps: "Us vs other coupon protection apps",
  title: "Welcome to KeepCart!",
};

export const BookDemoCard = () => {
  const t = i18nLike(en);
  const navigate = useNavigate();

  const [isVisible, setIsVisible] = useState<boolean>(!!sessionStorage.getItem("bookDemoCardDismissed"));

  const handleDismiss = () => {
    setIsVisible(false);
    sessionStorage.setItem("bookDemoCardDismissed", "true");
  };

  if (!isVisible) {
    return null;
  }

  return (
    <Layout.Section variant="fullWidth">
      <Card padding="500">
        <BlockStack gap="100">
          <InlineStack align="space-between" blockAlign="start">
            <Text as="h2" variant="headingMd">
              {t("title")}
            </Text>
            <Button icon={XSmallIcon} onClick={handleDismiss} variant="plain" />
          </InlineStack>
          <BlockStack gap="300">
            <Text as="p" variant="bodyMd">
              {t("description")}
            </Text>
            <ButtonGroup>
              <Button target="_blank" url="https://zcal.co/i/r7H4VFUJ" variant="secondary">
                {t("bookCall")}
              </Button>
              <Button
                onClick={() => {
                  navigate(routeConfig.appComparison["/"]);
                }}
                variant="secondary"
              >
                {t("otherCouponProtectionApps")}
              </Button>
            </ButtonGroup>
          </BlockStack>
        </BlockStack>
      </Card>
    </Layout.Section>
  );
};
